// src/routes/PrivateAdminRoute.js
import { Navigate, useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";
import Api from "../../../../shared/api/api";
import { adminReturnPath } from "../../../../shared/helpers/adminReturnPath";

export default function PrivateAdminRoute({ children }) {
  const location = useLocation();
  const destination = adminReturnPath(location.pathname + location.search + location.hash);
  const login = `/login?${new URLSearchParams({ next: destination })}`;
  const token = localStorage.getItem("token");

  if (!token) return <Navigate to={login} replace />;

  try {
    const decoded = jwtDecode(token);
    const expired = decoded?.exp && decoded.exp * 1000 <= Date.now();

    if (expired) {
      localStorage.removeItem("token");
      localStorage.removeItem("admin");
      Api.clearToken();
      return <Navigate to={login} replace />;
    }

    if (
      decoded.admin === true ||
      decoded.admin === 1 ||
      decoded.admin === "1" ||
      decoded.admin === "true"
    ) {
      return children;
    }
  } catch (err) {
    localStorage.removeItem("token");
    localStorage.removeItem("admin");
    Api.clearToken();
    return <Navigate to={login} replace />;
  }

  return <Navigate to="/" replace />;
}
